<template>
  <div class="advWrap" id="page4">
   <h2>引领新的营销方式</h2>
   <div class="advMain">
     <div class="leftBlock">
       <h3 class="title">链接国家标识</h3>
       <p class="message">
         涿溪防窜货对接工业互联网标识解析，通过使用涿溪防窜货，链接国家标识，强化企业、产品背书，让用户对企业放心，产品用的安心。
       </p>
       <div class="buttonWrap"><Mybutton @clickFn="showForm">了解国家标识</Mybutton></div>
     </div>
     <div class="rightBlock">
       <transition name="gxb">
         <img class="gxb" v-show="advShow" src="../assets/images/gxb.png" />
       </transition>
       <transition name="fdj">
          <img class="fdj" v-show="advShow" src="../assets/images/fdj.png" />
       </transition>
     </div>
   </div>
  </div>
</template>
<script>
import Mybutton from './Mybutton'
export default {
  name: 'codeAdv',
  components: {
    Mybutton
  },
  props: {
    advShow: Boolean
  },
  data () {
    return {

    }
  },
  methods: {
    showForm () {
      this.$emit('changeVisible', true)
    }
  }
}
</script>
<style scoped lang="scss">
/**放大镜动画**/
.fdj{
  position: absolute;
  left: 403px;
  top: 156px;
  // animation: fdj-in-out 3s ease-in-out .1s infinite
}
.fdj-enter-active {
  animation: fdj-in-out 1s;
  animation-delay: .1s;
}
.fdj-leave-active {
  animation: fdj-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes fdj-in-out {
  0% {
    left: 403px;
    top: 156px;
    opacity: 1;
    transform: scale(0.5)
  }
  60%{
    left: 600px;
    top: 120px;
    opacity: 1;
  }
  // 100% {
  //   left: 403px;
  //   top: 156px;
  //   opacity: 1;
  //   transform: scale(1)
  // }
}

/**工信部动画**/
.gxb{
  position: absolute;
  top: 109px;
  left: 508px;
  // animation: gxb-in-out 3s ease-in-out .1s infinite
}
.gxb-enter-active {
  animation: gxb-in-out .4s;
  animation-delay: .3s;
}
.gxb-leave-active {
  // animation: gxb-in-out 0 reverse;
  // animation-delay: 0;
}

@keyframes gxb-in-out {
  0% {
    transform: scale(0.7);
    opacity: 0;
  }
  // 30% {
  //   transform: scale(0.7);
  // }
  // 60%{
  //   // transform: scale(1);
  //   opacity: 1;
  // }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.advWrap{
  padding: 0 100px;
  > h2 {
    font-size: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 56px;
    padding: 103px 0 174px;
    margin: 0;
    text-align: center;
  }
  .advMain{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding-bottom: 110px;
    .leftBlock{
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
        width: 400px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 670px;
      height: 316px;
      background: url('../assets/images/bg_3.png') top left no-repeat;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CodeAdv.vue